export default "__VITE_ASSET__D0lSx9fs__"